import { StyleSheet } from 'aphrodite/no-important';

let styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%'
  },
  adminSidebarContainer: {
    display: 'flex',
    flexDirection: 'row',
    height: '100%'
  },
  adminContainer: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    width: 'calc(100% - 225px)'
  }
};

export default StyleSheet.create(styles);



// WEBPACK FOOTER //
// ./src/router/Router.styles.js